<style>

.title-signup{
  margin-top: 4%;
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
  max-height: 60%;
  overflow-y: auto;
}

.optional{
  text-align: center;
  color: white;
  font-size: 15px;
  margin: auto;
  margin-top: 10px;
  max-width: 220px;
}

.list{
  position: fixed;
  top: 160px;
  left: 0;
  right: 0;
  bottom: 150px;
  z-index: 2;
  overflow-y: auto;
}

.item{
  display: grid;
  grid-template-columns: 40px auto;
  color: white;
  margin: 10px 40px 0 40px;
  padding: 10px 0;
}
.check{
  grid-column: 1;
  text-align: center;
}
.text{
  grid-column: 2;
}

button.show-all{
  border: none;
  background-color: rgba(255,255,255,0.5);
  color: black;
  margin: 20px 0 0 80px;
  width: auto;
  font-size: 20px;
}
button.show-all:hover{
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
}

.small-margin{
  margin-top: 10px;
  color: white;
}
.large-margin{
  margin-top: 30px;
}

p{
  color: white;
  font-size: 15px;
}

.search-results{
  background-color: rgba(255,255,255,0.2);
  height: 200px;
  overflow-y: auto;
  color: white;
}
.search-item{
  margin: 10px;
}
</style>


<div class="bg">
  <div class="title-signup">Location Info</div>
  <div class="optional">We need your location to find events and people near you</div>
  
  <RadioList list="{locationTypes}" bind:selected="{locationSelected}"></RadioList>
  
  {#if locationSelected == "Use GPS (Street Level)"}
    <div class="large-margin">
      <button on:click="{ () => capture('street') }">Get My Location</button>
    </div>
  {/if}
  
  {#if locationSelected == "Use GPS (City Level)"}
    <div class="large-margin">
      <button on:click="{ () => capture('city') }">Get My Location</button>
    </div>
  {/if}
  
  
  {#if locationSelected == "Enter City Name"}
    <p>This might not work well for you depending on how far away you are from the city center...</p>
    <div class="small-margin">
      <ValidInput bind:value="{city}" valid="{found}" on:changed="{cityChanged}"></ValidInput>
    </div>
    
    {#if searchItems.length}
      <div class="search-results">
        {#each searchItems as item}
          <div class="search-item" on:click="{ () => citySelected(item) }">{item.n}</div>
        {/each}
      </div>
    {:else if found}
      <div><!-- empty on purpose --></div>
    {:else if noSearch}
      <div class="small-margin">Please type a city name above.</div>
    {:else if city == ""}
      <div class="small-margin">City can't be empty.  Only cities in Los Angeles and Orange County, USA are supported at this time. </div>
    {:else}
      <div class="small-margin">Nothing found...</div>
    {/if}
  {/if}
  
  <div class="has-buttons"></div>
  
</div>

<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>


<script>


import {push, pop, replace, location, link} from 'svelte-spa-router';

import NextButton from "../../../../components/NextButton.svelte";
import RadioList from "../../../../components/RadioList.svelte";
import ValidInput from "../../../../components/ValidInput.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Cities from "../../../../helpers/Cities.js";
import {randoGPS} from "../../../../helpers/Geo.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("lat", 0);
  // Signup.saveToPersonalObject("long", 0);
  // Signup.saveToPersonalObject("locationSaved", false);
  
  locationSaved = Signup.getPersonalObject("locationSaved");
  lat = Signup.getPersonalObject("lat");
  long = Signup.getPersonalObject("long");

  if (locationSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

// $:{
//   console.log("lat, long:", lat, long);
// }

let allowSignup = false;
let showAll = false;
let locationType = -1;
let nextDisabled = true;
let locationTypes = [
  "Use GPS (Street Level)",
  "Use GPS (City Level)",
  "Enter City Name",
];
let locationSelected = "Use GPS (Street Level)";
// let locationSelected = "Enter City Name";

let city = "";
let searchItems = [];
let found = false;
let noSearch = true;

let lat = 0;
let long = 0;
let locationSaved = false;


let watchID = null;
function capture(accuracy) {
  
  const options = {
    enableHighAccuracy: accuracy == 'street' ? true : false,
    maximumAge: 30000,
    timeout: 27000
  };
  
  if('geolocation' in navigator) {
    watchID = navigator.geolocation.watchPosition(captureSuccess, captureFail, options);
  } else {
    // error
  }
}


let captures = 0;
function captureSuccess(position) {
  // console.log("position:", position);
  lat = position.coords.latitude;
  long = position.coords.longitude;
  
  check();
  
  captures++;
  if (captures > 2) {
    navigator.geolocation.clearWatch(watchID);
  }
}


function captureFail() {
  console.log("gps capture failed");
}


function cityChanged(e) {
  found = false;
  noSearch = false;
  searchItems = [];
  
  if (city != "") {
    let searchFor = city.toLowerCase();
    
    for (let i in Cities.gps) {
      if (i.includes(searchFor) == true) {
        searchItems.push(Cities.gps[i]);
      }
    }
  }
}


function citySelected(item) {
  found = true;
  searchItems = [];
  lat = item.lt;
  long = item.lg;
  city = item.n;
  check();
}


function check() {
  locationSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    if (lat == 0 & long == 0) throw "no location selected";
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (locationSaved == false) {
    
    // we need to randomize the location a little bit so we don't have an
    // exact location for privacy reasons
    // 33.872333, -117.932508
    // 33.872297, -117.933699
    
    // something like above should turn into something like below:
    // 33.872, -117.935
    
    // lop off anything after the third decimal place and then add a 
    // little bit of randomness
    // let tlat = Math.round( ( lat + ( ( Math.random() - 0.5) / 100 ) ) * 1000) / 1000;
    // let tlong = Math.round( ( long + ( ( Math.random() - 0.5) / 100 ) ) * 1000) / 1000;
    
    // console.log("randomized lat,long to save:", tlat + ", " + tlong);
    
    let {tlat, tlong} = randoGPS(lat, long);
    
    await Signup.saveToPersonalObject("lat", tlat);
    await Signup.saveToPersonalObject("long", tlong);
    await Signup.saveToPersonalObject("locationSaved", true);
    await Signup.saveMe("lat,long");
    await Signup.saveLocation();
  }
  
  push("/signup/profile/personal/thankyou");
}


</script>